<template>
  <v-text-field
      :error-messages="error"
      :label="translation(translationList.token, 'Cod resetare')"
      v-model="resetToken"
      :rules="resetTokenValidationRules"
      name="reset_token"
      variant="outlined"
      :tile="true"
      type="number"
      counter="6"
  >
    <template v-slot:append-inner>
      <v-tooltip location="top" open-delay="500" open-on-click open-on-hover>
        <template v-slot:activator="{ props }">
           <v-icon v-bind="props" class="cursor-pointer" aria-label="info">mdi-information</v-icon>
        </template>
        <div>{{ translation(translationList.reset_token_helper, 'Codul a fost trimis catre dumneavoastra pe adresa de email completata') }}</div>
      </v-tooltip>
    </template>
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type { TranslationList } from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
  },
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const resetToken = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const resetTokenValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => /^\d{6}$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateResetToken(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = resetTokenValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return resetTokenValidationRules.every(rule => rule(value) === true);
    }

    watch(resetToken, (newValue) => {
      const isValid = validateResetToken(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', '');
      }
      emit('validation-customer-status', { field: 'reset_token', isValid });
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateResetToken(resetToken.value);
      emit('validation-customer-status', { field: `reset_token`, isValid });

      window.addEventListener('validate-customer', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === 'reset_token') {
        const isValid = validateResetToken(resetToken.value, true);
        if (isValid) {
          emit('validation-customer-status', { field: 'reset_token', isValid });
        }
      }
    };

    return {
      resetToken,
      resetTokenValidationRules,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>